<template>
  <section class="py-12">
    <div class="container-wrap">
      <h2 class="text-h1 mb-6">{{ sectionData.name }}</h2>
      <CarouselProduct
        :carousel-list="contextResources"
        :has-image-border="false"
        :is-click-card="false"
      />
    </div>
  </section>
</template>

<script setup lang="ts">
  import type { ISection } from '@/assets/types/api/Pages';
  import type { IProductCarousel } from '@/components/Shared/Carousel/types';

  interface IProps {
    sectionData: ISection;
  }

  const props = withDefaults(defineProps<IProps>(), {
    sectionData: () => ({
      code: null,
      name: null,
      description: null,
      type: 1,
      imageUrl: null,
      imageAlt: null,
      link: null,
      align: null,
      theme: null,
      subSections: [],
    }),
  });

  const contextResources = computed((): IProductCarousel[] => {
    return props.sectionData.subSections.map(
      ({ name, description, imageUrl, link }: ISection) => ({
        name: name || '',
        description: description || '',
        imageUrl: imageUrl || '',
        buttonName: link?.name ?? '',
        buttonUrl: link?.url ?? '',
      })
    );
  });
</script>
